var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_4126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 25.9999H26.7101L26.4301 25.7299C27.6301 24.3299 28.2501 22.4199 27.9101 20.3899C27.4401 17.6099 25.1201 15.3899 22.3201 15.0499C18.0901 14.5299 14.5301 18.0899 15.0501 22.3199C15.3901 25.1199 17.6101 27.4399 20.3901 27.9099C22.4201 28.2499 24.3301 27.6299 25.7301 26.4299L26.0001 26.7099V27.4999L30.2501 31.7499C30.6601 32.1599 31.3301 32.1599 31.7401 31.7499C32.1501 31.3399 32.1501 30.6699 31.7401 30.2599L27.5001 25.9999ZM21.5001 25.9999C19.0101 25.9999 17.0001 23.9899 17.0001 21.4999C17.0001 19.0099 19.0101 16.9999 21.5001 16.9999C23.9901 16.9999 26.0001 19.0099 26.0001 21.4999C26.0001 23.9899 23.9901 25.9999 21.5001 25.9999Z",
    fill: "#6E7191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_4126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.924754835aa84e87d0f8e269c21ab9f4.svg";
export { ForwardRef as ReactComponent };